<div class="flex min-h-[calc(100vh-6.5rem)] h-[calc(100vh-6.5rem)] overflow-hidden bg-gray-50 border border-gray-200 rounded-2xl shadow-sm">

  <!-- ── LEFT SIDEBAR — Client list ── -->
  <div class="w-80 bg-white border-r border-gray-200 flex flex-col shrink-0">
    <!-- Header -->
    <div class="p-4 border-b border-gray-100 space-y-3">
      <div class="flex items-center justify-between">
        <h2 class="text-lg font-bold text-gray-900">
          Clients <span class="ml-1 text-sm font-medium text-gray-400">{{ filteredClients.length }}</span>
        </h2>
        <button (click)="openNewClientModal()"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" /></svg>
          New
        </button>
      </div>

      <!-- Tenant filter -->
      <div class="relative">
        <select [(ngModel)]="selectedTenantFilter" (change)="onTenantFilterChange()"
          class="w-full appearance-none pl-3 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
          [class]="selectedTenantFilter ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
          <option value="">All tenants</option>
          @for (t of tenants; track t.id) { <option [value]="t.id">{{ t.name }}</option> }
        </select>
        <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>

      <!-- Kind filter -->
      <div class="relative">
        <select [(ngModel)]="selectedTypeFilter" (ngModelChange)="filterClients()"
          class="w-full appearance-none pl-3 pr-8 py-2 text-sm font-medium border rounded-lg cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
          [class]="selectedTypeFilter ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
          <option value="">All kinds</option>
          @for (t of clientTypes; track t.value) { <option [value]="t.value">{{ t.label }}</option> }
        </select>
        <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
      </div>

      <!-- Search -->
      <div class="relative">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
        <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="filterClients()" placeholder="Search clients…"
          class="w-full pl-9 pr-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all placeholder-gray-400">
      </div>
    </div>

    <!-- List -->
    <div class="flex-1 overflow-y-auto custom-scrollbar">
      @if (isLoading) {
      @for (i of [1,2,3,4,5]; track i) {
      <div class="flex items-center gap-3 p-3 border-b border-gray-50 animate-pulse">
        <div class="w-9 h-9 rounded-lg bg-gray-200 shrink-0"></div>
        <div class="flex-1"><div class="h-3.5 bg-gray-200 rounded w-3/4 mb-2"></div><div class="h-3 bg-gray-100 rounded w-1/2"></div></div>
      </div>
      }
      } @else if (filteredClients.length === 0) {
      <div class="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div class="w-12 h-12 mb-3 rounded-2xl bg-gray-100 flex items-center justify-center">
          <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
        </div>
        <p class="text-sm font-medium text-gray-500">{{ searchQuery ? 'No matches' : 'No clients yet' }}</p>
        <p class="text-xs text-gray-400 mt-0.5">{{ searchQuery ? 'Try a different search' : 'Create your first client' }}</p>
      </div>
      } @else {
      @for (client of filteredClients; track client.id) {
      @let cm = monogram(client.name);
      <div (click)="selectClient(client)"
        class="flex items-start gap-3 p-3 border-b border-gray-50 border-l-2 cursor-pointer transition-colors"
        [class.bg-blue-50]="selectedClient?.id === client.id"
        [class.border-l-blue-600]="selectedClient?.id === client.id"
        [class.border-l-transparent]="selectedClient?.id !== client.id"
        [class.hover:bg-gray-50]="selectedClient?.id !== client.id">
        <span class="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-lg text-[11px] font-bold" [style.background]="cm.bg" [style.color]="cm.fg">{{ cm.text }}</span>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-1.5 min-w-0">
            <span class="font-semibold text-sm text-gray-900 truncate">{{ client.name }}</span>
            <span class="shrink-0 inline-flex items-center px-1.5 py-0.5 rounded-md text-[10px] font-semibold border"
              [ngClass]="typeClass(client.type)">{{ typeLabel(client.type) }}</span>
          </div>
          @if (getTenantName(client.tenantId); as tenantName) { <div class="text-xs text-blue-600 font-medium truncate">{{ tenantName }}</div> }
          @if (client.email) { <div class="text-xs text-gray-500 truncate">{{ client.email }}</div> }
        </div>
      </div>
      }
      }
    </div>
  </div>

  <!-- ── RIGHT PANEL — Client details ── -->
  <div class="flex-1 flex flex-col overflow-hidden">
    @if (!selectedClient) {
    <div class="flex-1 flex items-center justify-center">
      <div class="text-center">
        <div class="mx-auto w-16 h-16 rounded-2xl bg-white border border-gray-200 shadow-sm flex items-center justify-center">
          <svg class="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
        </div>
        <h3 class="mt-3 text-sm font-semibold text-gray-700">No client selected</h3>
        <p class="mt-1 text-sm text-gray-400">Pick a client from the list to see their details</p>
      </div>
    </div>
    } @else {

    <!-- Client header -->
    <div class="bg-white border-b border-gray-100 px-6 py-5">
      <div class="flex items-start justify-between gap-4">
        <div class="flex items-center gap-4 min-w-0">
          @let hm = monogram(selectedClient.name);
          <span class="shrink-0 inline-flex items-center justify-center w-14 h-14 rounded-2xl text-lg font-bold shadow-sm" [style.background]="hm.bg" [style.color]="hm.fg">{{ hm.text }}</span>
          <div class="min-w-0">
            <h1 class="text-2xl font-bold text-gray-900 truncate">{{ selectedClient.name }}</h1>
            <div class="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-gray-500">
              @if (selectedClient.email) {
              <span class="inline-flex items-center gap-1.5 min-w-0">
                <svg class="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                <span class="truncate">{{ selectedClient.email }}</span>
              </span>
              }
              @if (selectedClient.phone) {
              <span class="inline-flex items-center gap-1.5">
                <svg class="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                {{ selectedClient.phone }}
              </span>
              }
            </div>
          </div>
        </div>
        <div class="flex gap-2 shrink-0">
          <button (click)="openEditClientModal()"
            class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
            Edit
          </button>
          <button (click)="deleteClient($event)"
            class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
            Delete
          </button>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="bg-white border-b border-gray-200">
      <nav class="flex items-center gap-6 px-6">
        <button (click)="activeTab = 'info'"
          class="flex items-center gap-2 pb-3 pt-2 -mb-px text-sm font-semibold border-b-2 transition-colors cursor-pointer"
          [class]="activeTab === 'info' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-800'">
          Information
        </button>
        <button (click)="activeTab = 'projects'"
          class="flex items-center gap-2 pb-3 pt-2 -mb-px text-sm font-semibold border-b-2 transition-colors cursor-pointer"
          [class]="activeTab === 'projects' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-800'">
          Projects
          @if (clientProjects.length > 0) { <span class="px-2 py-0.5 text-xs font-semibold bg-gray-100 text-gray-600 rounded-full">{{ clientProjects.length }}</span> }
        </button>
        <button (click)="activeTab = 'todos'"
          class="flex items-center gap-2 pb-3 pt-2 -mb-px text-sm font-semibold border-b-2 transition-colors cursor-pointer"
          [class]="activeTab === 'todos' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-800'">
          Tasks
          @if (clientTodos.length > 0) { <span class="px-2 py-0.5 text-xs font-semibold bg-gray-100 text-gray-600 rounded-full">{{ clientTodos.length }}</span> }
        </button>
      </nav>
    </div>

    <!-- Tab content -->
    <div class="flex-1 overflow-y-auto bg-gray-50/60 p-6 custom-scrollbar">

      @if (activeTab === 'info') {
      <div class="bg-white rounded-2xl border border-gray-200 shadow-sm divide-y divide-gray-100">
        @if (selectedClient.email) {
        <div class="flex items-center gap-3 px-5 py-3.5">
          <span class="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 inline-flex items-center justify-center shrink-0">
            <svg class="w-4.5 h-4.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          </span>
          <div class="min-w-0">
            <div class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Email</div>
            <a [href]="'mailto:' + selectedClient.email" class="text-sm text-gray-800 hover:text-blue-600 truncate block">{{ selectedClient.email }}</a>
          </div>
        </div>
        }
        @if (selectedClient.phone) {
        <div class="flex items-center gap-3 px-5 py-3.5">
          <span class="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-600 inline-flex items-center justify-center shrink-0">
            <svg class="w-4.5 h-4.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
          </span>
          <div class="min-w-0">
            <div class="text-xs text-gray-400 font-semibold uppercase tracking-wide">Phone</div>
            <a [href]="'tel:' + selectedClient.phone" class="text-sm text-gray-800 hover:text-emerald-600 truncate block">{{ selectedClient.phone }}</a>
          </div>
        </div>
        }
        @if (clientTenantLinks.length > 0 || getTenantName(selectedClient.tenantId)) {
        <div class="flex items-start gap-3 px-5 py-3.5">
          <span class="w-9 h-9 rounded-xl bg-indigo-50 text-indigo-600 inline-flex items-center justify-center shrink-0">
            <svg class="w-4.5 h-4.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
          </span>
          <div class="min-w-0">
            <div class="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-1.5">{{ clientTenantLinks.length > 1 ? 'Tenants' : 'Tenant' }}</div>
            <div class="flex flex-wrap gap-1.5">
              @if (clientTenantLinks.length > 0) {
              @for (tl of clientTenantLinks; track tl.id) {
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-indigo-50 text-indigo-700 border border-indigo-100">{{ tl.tenant?.name || tl.tenantId }}</span>
              }
              } @else if (getTenantName(selectedClient.tenantId); as tenantName) {
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-indigo-50 text-indigo-700 border border-indigo-100">{{ tenantName }}</span>
              }
            </div>
          </div>
        </div>
        }
        @if (selectedClient.address || selectedClient.fullAddress) {
        <div class="flex items-start gap-3 px-5 py-3.5">
          <span class="w-9 h-9 rounded-xl bg-amber-50 text-amber-600 inline-flex items-center justify-center shrink-0">
            <svg class="w-4.5 h-4.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
          </span>
          <div class="min-w-0 text-sm text-gray-800">
            <div class="text-xs text-gray-400 font-semibold uppercase tracking-wide mb-1">Address</div>
            @if (selectedClient.fullAddress) { {{ selectedClient.fullAddress }} }
            @else if (selectedClient.address) {
            <div class="space-y-0.5">
              @if (selectedClient.address.street) { <div>{{ selectedClient.address.street }}</div> }
              @if (selectedClient.address.city || selectedClient.address.state || selectedClient.address.zip) {
              <div>{{ selectedClient.address.city }}@if (selectedClient.address.city && selectedClient.address.state) {, }{{ selectedClient.address.state }} {{ selectedClient.address.zip }}</div>
              }
              @if (selectedClient.address.country) { <div>{{ selectedClient.address.country }}</div> }
            </div>
            }
          </div>
        </div>
        }
        @if (!selectedClient.email && !selectedClient.phone && !selectedClient.address && !selectedClient.fullAddress && clientTenantLinks.length === 0 && !getTenantName(selectedClient.tenantId)) {
        <div class="px-5 py-10 text-center text-sm text-gray-400">No additional details yet — use <span class="font-medium text-gray-500">Edit</span> to add contact info.</div>
        }
      </div>
      }

      @else if (activeTab === 'projects') {
      <div class="space-y-3">
        <h3 class="text-sm font-bold text-gray-400 uppercase tracking-wider">Linked projects</h3>
        @if (clientProjects.length === 0) {
        <div class="bg-white rounded-2xl border border-dashed border-gray-200 p-10 text-center">
          <div class="mx-auto w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center mb-3">
            <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /></svg>
          </div>
          <p class="text-sm font-medium text-gray-500">No linked projects</p>
          <p class="text-xs text-gray-400 mt-0.5">Projects linked to this client will appear here.</p>
        </div>
        } @else {
        <div class="space-y-2">
          @for (proj of clientProjects; track proj.id) {
          <a [routerLink]="['/projects', proj.id]" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-3 px-4 py-3 rounded-xl bg-white border border-gray-200 shadow-sm hover:border-indigo-200 hover:shadow-md transition-all cursor-pointer group">
            <div class="shrink-0 w-9 h-9 bg-indigo-50 rounded-xl flex items-center justify-center">
              <svg class="w-4.5 h-4.5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /></svg>
            </div>
            <span class="flex-1 text-sm font-semibold text-gray-800 group-hover:text-indigo-700 truncate">{{ proj.projectName }}</span>
            <svg class="w-4 h-4 text-gray-300 group-hover:text-indigo-500 transition-colors shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
          </a>
          }
        </div>
        }
      </div>
      }

      @else {
      <div class="space-y-4">
        <div class="flex items-center justify-between">
          <h3 class="text-sm font-bold text-gray-400 uppercase tracking-wider">Client tasks</h3>
          <button (click)="openNewTodoModal()"
            class="inline-flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" /></svg>
            New Task
          </button>
        </div>

        @if (clientTodos.length === 0) {
        <div class="bg-white rounded-2xl border border-dashed border-gray-200 p-10 text-center">
          <div class="mx-auto w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center mb-3">
            <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>
          </div>
          <p class="text-sm font-medium text-gray-500">No tasks yet</p>
          <p class="text-xs text-gray-400 mt-0.5">Create a task to track work for this client.</p>
        </div>
        } @else {
        <div class="space-y-2.5">
          @for (todo of clientTodos; track todo.id) {
          @let isDone = todo.status === 'DONE';
          <div class="bg-white rounded-xl border border-gray-200 px-4 py-3.5 flex items-start gap-3.5 hover:shadow-sm hover:border-gray-300 transition-all group">
            <div class="shrink-0 mt-1 w-2 h-2 rounded-full" [class]="isDone ? 'bg-emerald-500' : todo.status === 'IN_PROGRESS' ? 'bg-blue-500' : 'bg-slate-300'"></div>
            <div class="flex-1 min-w-0 cursor-pointer" (click)="openTaskDetail(todo)">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-semibold text-sm text-gray-900 group-hover:text-blue-700 transition-colors" [class.line-through]="isDone" [class.text-gray-400]="isDone">{{ todo.name }}</span>
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border" [class]="getTodoStatusBadgeClass(todo.status)">{{ getTodoStatusLabel(todo.status) }}</span>
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border" [class]="getTodoPriorityBadgeClass(todo.priority)">{{ getTodoPriorityLabel(todo.priority) }}</span>
              </div>
              @if (todo.description) { <p class="text-xs text-gray-500 mt-1 line-clamp-1">{{ todo.description }}</p> }
              @if (todo.dueDate) {
              <span class="text-xs mt-1.5 inline-flex items-center gap-1" [class]="isTodoOverdue(todo.dueDate) && !isDone ? 'text-red-600 font-semibold' : 'text-gray-400'">
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                {{ todo.dueDate | date:'MMM d, y' }}
              </span>
              }
            </div>
            <div class="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
              <button (click)="openEditTodoModal($event, todo)" class="p-1.5 rounded-lg text-gray-400 hover:text-blue-600 hover:bg-blue-50 transition-colors cursor-pointer" title="Edit">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
              </button>
              <button (click)="deleteTodo($event, todo)" class="p-1.5 rounded-lg text-gray-400 hover:text-red-600 hover:bg-red-50 transition-colors cursor-pointer" title="Delete">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
              </button>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>

<!-- ══ Client modal ══ -->
@if (showClientModal) {
<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4" (click)="closeClientModal()">
  <div class="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[92vh] flex flex-col overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
        </div>
        <div>
          <h3 class="text-lg font-bold text-gray-900 leading-tight">{{ isEditingClient ? 'Edit client' : 'New client' }}</h3>
          <p class="text-xs text-gray-400">{{ isEditingClient ? 'Update client details' : 'Add a client to your CRM' }}</p>
        </div>
      </div>
      <button (click)="closeClientModal()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-6 py-5 space-y-6 overflow-y-auto flex-1 min-h-0 bg-gray-50/40 custom-scrollbar">

      <!-- Contact -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-4">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
          Contact
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Name <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="clientForm.name" placeholder="Client name"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Kind</label>
          <select [(ngModel)]="clientForm.type"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm bg-white cursor-pointer focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition">
            @for (t of clientTypes; track t.value) { <option [value]="t.value">{{ t.label }}</option> }
          </select>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="flex flex-col">
            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Email</label>
            <input type="email" [(ngModel)]="clientForm.email" placeholder="email@example.com"
              class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
          </div>
          <div class="flex flex-col">
            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Phone</label>
            <input type="tel" [(ngModel)]="clientForm.phone" placeholder="+32 ..."
              class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
          </div>
        </div>
      </div>

      <!-- Organisation (tenants) -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-3">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
          Tenants @if(selectedTenantIds.size) { <span class="text-blue-600 normal-case">({{ selectedTenantIds.size }})</span> }
        </div>
        @if (tenants.length === 0) {
        <p class="text-sm text-gray-400 italic">No tenants available</p>
        } @else {
        <div class="flex flex-wrap gap-2">
          @for (t of tenants; track t.id) {
          <button type="button" (click)="toggleTenantSelection(t.id)"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium border transition-all cursor-pointer"
            [class]="isTenantSelected(t.id) ? 'bg-blue-600 text-white border-blue-600 shadow-sm' : 'bg-white text-gray-600 border-gray-300 hover:border-blue-400 hover:bg-blue-50'">
            @if(isTenantSelected(t.id)) {
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" /></svg>
            }
            {{ t.name }}
          </button>
          }
        </div>
        }
      </div>

      <!-- Address -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-3">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
          Address
        </div>
        <input type="text" [(ngModel)]="addressForm.street" placeholder="Street address"
          class="w-full border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
        <div class="grid grid-cols-2 gap-3">
          <input type="text" [(ngModel)]="addressForm.city" placeholder="City"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
          <input type="text" [(ngModel)]="addressForm.state" placeholder="State / Province"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
        </div>
        <div class="grid grid-cols-2 gap-3">
          <input type="text" [(ngModel)]="addressForm.zip" placeholder="ZIP / Postal code"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
          <div class="relative">
            <select [(ngModel)]="addressForm.country"
              class="w-full appearance-none border border-gray-300 rounded-lg pl-3.5 pr-9 py-2.5 text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none cursor-pointer transition">
              <option value="" disabled selected>Country</option>
              @for (country of countries; track country.value) { <option [value]="country.value">{{ country.name }}</option> }
            </select>
            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3.5 border-t border-gray-100 flex justify-end gap-2 shrink-0 bg-gray-50/50">
      <button (click)="closeClientModal()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Cancel</button>
      <button (click)="saveClient()" class="bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">{{ isEditingClient ? 'Save changes' : 'Create client' }}</button>
    </div>
  </div>
</div>
}

<!-- ══ Task modal (create / edit) ══ -->
@if (showTodoModal) {
<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4" (click)="closeTodoModal()">
  <div class="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[92vh] flex flex-col overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>
        </div>
        <div>
          <h3 class="text-lg font-bold text-gray-900 leading-tight">{{ isEditingTodo ? 'Edit task' : 'New task' }}</h3>
          <p class="text-xs text-gray-400">{{ isEditingTodo ? 'Update the task details' : 'Add a task for this client' }}</p>
        </div>
      </div>
      <button (click)="closeTodoModal()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-6 py-5 space-y-6 overflow-y-auto flex-1 min-h-0 bg-gray-50/40 custom-scrollbar">

      <!-- Details -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-4">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
          Details
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Title <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="todoForm.name" placeholder="What needs to be done?"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 transition">
        </div>
        <div class="flex flex-col">
          <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Description</label>
          <textarea [(ngModel)]="todoForm.description" rows="3" placeholder="Add more context…"
            class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none placeholder-gray-400 resize-y transition"></textarea>
        </div>
      </div>

      <!-- Classification -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-4">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5a1.99 1.99 0 011.414.586l7 7a2 2 0 010 2.828l-5 5a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" /></svg>
          Classification
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div class="flex flex-col">
            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Status</label>
            <div class="grid grid-cols-3 gap-1.5">
              <button type="button" (click)="todoForm.status = 'TODO'" class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer" [ngClass]="todoForm.status === 'TODO' ? 'bg-slate-50 border-slate-400 text-slate-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'"><span class="w-2 h-2 rounded-full bg-slate-400"></span> To Do</button>
              <button type="button" (click)="todoForm.status = 'IN_PROGRESS'" class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer" [ngClass]="todoForm.status === 'IN_PROGRESS' ? 'bg-blue-50 border-blue-400 text-blue-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'"><span class="w-2 h-2 rounded-full bg-blue-500"></span> In Progress</button>
              <button type="button" (click)="todoForm.status = 'DONE'" class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer" [ngClass]="todoForm.status === 'DONE' ? 'bg-emerald-50 border-emerald-400 text-emerald-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'"><span class="w-2 h-2 rounded-full bg-emerald-500"></span> Done</button>
            </div>
          </div>
          <div class="flex flex-col">
            <label class="text-xs text-gray-500 font-semibold mb-1.5 uppercase tracking-wide">Priority</label>
            <div class="grid grid-cols-3 gap-1.5">
              <button type="button" (click)="todoForm.priority = 'LOW'" class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer" [ngClass]="todoForm.priority === 'LOW' ? 'bg-gray-50 border-gray-400 text-gray-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'"><span class="w-2 h-2 rounded-full bg-gray-400"></span> Low</button>
              <button type="button" (click)="todoForm.priority = 'MEDIUM'" class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer" [ngClass]="todoForm.priority === 'MEDIUM' ? 'bg-amber-50 border-amber-400 text-amber-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'"><span class="w-2 h-2 rounded-full bg-amber-500"></span> Medium</button>
              <button type="button" (click)="todoForm.priority = 'HIGH'" class="flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-semibold border transition-all cursor-pointer" [ngClass]="todoForm.priority === 'HIGH' ? 'bg-red-50 border-red-400 text-red-700' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'"><span class="w-2 h-2 rounded-full bg-red-500"></span> High</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Schedule & Scope -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-4">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
          Schedule &amp; Scope
        </div>

        <div class="flex flex-col gap-3">
          <label class="flex items-center gap-2.5 cursor-pointer">
            <input type="checkbox" [(ngModel)]="hasDueDate" (change)="onDueDateToggle()" class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
            <span class="text-sm font-semibold text-gray-700">Set a due date</span>
          </label>
          @if (hasDueDate) {
          <input type="date" [(ngModel)]="todoForm.dueDate" class="border border-gray-300 rounded-lg px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition">
          }
        </div>

        <!-- Scope cascade: Tenant → Client → Project -->
        <div class="rounded-lg border border-gray-100 bg-gray-50/60 p-3 space-y-3">
          <p class="text-[11px] font-semibold text-gray-500 uppercase tracking-wide">Scope (optional)</p>
          <div class="relative">
            <select [(ngModel)]="todoForm.tenantId" (change)="onTodoTenantChange()"
              class="w-full appearance-none border border-gray-300 rounded-lg pl-3 pr-9 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-400 outline-none cursor-pointer transition">
              <option [ngValue]="undefined">— No tenant —</option>
              @for(t of tenants; track t.id) { <option [value]="t.id">{{ t.name }}</option> }
            </select>
            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
          </div>
          @if(todoForm.tenantId) {
          <div class="pl-3 border-l-2 border-blue-200 relative">
            <select [(ngModel)]="todoForm.clientId" (change)="onTodoClientChange()"
              class="w-full appearance-none border border-gray-300 rounded-lg pl-3 pr-9 py-2 text-sm bg-white focus:ring-2 focus:ring-blue-400 outline-none cursor-pointer transition">
              <option [ngValue]="undefined">— No client —</option>
              @for(c of filteredClientsForTodo; track c.id) { <option [value]="c.id">{{ c.name }}</option> }
            </select>
            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
          </div>
          }
          @if(todoForm.clientId) {
          <div class="pl-6 border-l-2 border-indigo-200 relative">
            <select [(ngModel)]="todoForm.projectId"
              class="w-full appearance-none border border-gray-300 rounded-lg pl-3 pr-9 py-2 text-sm bg-white focus:ring-2 focus:ring-indigo-400 outline-none cursor-pointer transition">
              <option [ngValue]="undefined">— No project —</option>
              @for(p of filteredProjectsForTodo; track p.id) { <option [value]="p.id">{{ p.projectName }}</option> }
            </select>
            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /></svg>
            @if(filteredProjectsForTodo.length === 0) { <p class="text-xs text-gray-400 mt-1 italic">No projects linked to this client yet</p> }
          </div>
          }
        </div>
      </div>

      <!-- Team -->
      <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-3">
        <div class="flex items-center gap-1.5 text-xs text-gray-400 font-bold uppercase tracking-wider">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4z" /></svg>
          Assign to @if(selectedUsers.length) { <span class="text-blue-600 normal-case">({{ selectedUsers.length }})</span> }
        </div>
        @if (assignableUsers.length > 0) {
        <div class="flex flex-wrap gap-2">
          @for (u of assignableUsers; track u.id) {
          <button type="button" (click)="toggleUserSelection(u.id)"
            class="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full text-sm font-medium border transition-all cursor-pointer"
            [class]="isUserSelected(u.id) ? 'bg-blue-600 text-white border-blue-600 shadow-sm' : 'bg-white text-gray-600 border-gray-300 hover:border-blue-400 hover:bg-blue-50'">
            <span class="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold" [class]="isUserSelected(u.id) ? 'bg-white/20 text-white' : 'bg-gradient-to-br from-blue-500 to-indigo-600 text-white'">{{ getInitials(u) }}</span>
            {{ u.firstName || u.name }}
            @if(u.isArchived) {
            <span class="inline-flex items-center px-1.5 py-0.5 rounded-md text-[9px] font-semibold uppercase tracking-wide"
              [class]="isUserSelected(u.id) ? 'bg-white/20 text-white' : 'bg-amber-100 text-amber-700 border border-amber-200'">Archived</span>
            }
          </button>
          }
        </div>
        } @else {
        <p class="text-sm text-gray-400 italic">No users available</p>
        }
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3.5 border-t border-gray-100 flex justify-end gap-2 shrink-0 bg-gray-50/50">
      <button (click)="closeTodoModal()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Cancel</button>
      <button (click)="saveTodo()" class="bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">{{ isEditingTodo ? 'Save changes' : 'Create task' }}</button>
    </div>
  </div>
</div>
}

<!-- ══ Read-only task detail ══ -->
@if (showTaskDetail && detailTask) {
@let isDone = detailTask.status === 'DONE';
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" (click)="closeTaskDetail()">
  <div class="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-2xl flex flex-col max-h-[90vh]" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 flex justify-between items-center shrink-0">
      <div class="flex items-center gap-3 min-w-0">
        <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shrink-0 shadow-sm">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>
        </div>
        <div class="min-w-0">
          <h2 class="font-bold text-lg text-gray-900 leading-tight truncate">Task details</h2>
          <p class="text-xs text-gray-400">Read-only overview</p>
        </div>
      </div>
      <div class="flex items-center gap-2 shrink-0">
        <button type="button" (click)="editFromTaskDetail()" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
          Edit
        </button>
        <button (click)="closeTaskDetail()" class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="px-6 py-5 overflow-y-auto custom-scrollbar flex-1 space-y-6 bg-gray-50/40">
      <div class="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <div class="h-1.5 w-full" [ngClass]="detailStatusAccent"></div>
        <div class="p-5 space-y-3">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border" [class]="getTodoStatusBadgeClass(detailTask.status)">{{ getTodoStatusLabel(detailTask.status) }}</span>
            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border" [class]="getTodoPriorityBadgeClass(detailTask.priority)">{{ getTodoPriorityLabel(detailTask.priority) }}</span>
            @if(detailIsOverdue) {
            <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border border-red-200 bg-red-50 text-red-700">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /></svg>
              Overdue
            </span>
            }
          </div>
          <h3 class="text-2xl font-bold text-gray-900 leading-snug break-words" [class.line-through]="isDone" [class.text-gray-400]="isDone">{{ detailTask.name }}</h3>
        </div>
      </div>

      <div class="rounded-xl border border-gray-200 bg-white p-4">
        <div class="flex items-center gap-1.5 text-xs text-gray-500 font-semibold mb-2 uppercase tracking-wide">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
          Description
        </div>
        @if(detailTask.description) {
        <p class="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">{{ detailTask.description }}</p>
        } @else {
        <p class="text-sm text-gray-400 italic">No description added</p>
        }
      </div>

      <div class="rounded-xl border bg-white p-4" [ngClass]="detailIsOverdue ? 'border-red-200 bg-red-50/60' : 'border-gray-200'">
        <div class="flex items-center gap-1.5 text-xs font-semibold mb-1 uppercase tracking-wide" [ngClass]="detailIsOverdue ? 'text-red-600' : 'text-gray-500'">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
          Due date
        </div>
        @if(detailTask.dueDate) {
        <div class="text-sm font-medium" [ngClass]="detailIsOverdue ? 'text-red-700' : 'text-gray-800'">{{ detailTask.dueDate | date:'MMM d, y' }}</div>
        <div class="text-xs mt-0.5" [ngClass]="detailIsOverdue ? 'text-red-500' : 'text-gray-400'">{{ detailDueRelative }}</div>
        } @else {
        <div class="text-sm text-gray-400 italic">No due date</div>
        }
      </div>

      <div>
        <div class="flex items-center gap-1.5 text-xs text-gray-500 font-semibold mb-2 uppercase tracking-wide">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4z" /></svg>
          Assigned to @if(detailAssignedUsers.length) { <span class="text-blue-600 normal-case">({{ detailAssignedUsers.length }})</span> }
        </div>
        @if(detailAssignedUsers.length > 0) {
        <div class="rounded-xl border border-gray-200 bg-white divide-y divide-gray-100 overflow-hidden">
          @for(u of detailAssignedUsers; track u.id) {
          <div class="flex items-center gap-3 px-3 py-2.5">
            <span class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-[10px] font-bold shrink-0">{{ getInitials(u) }}</span>
            <div class="min-w-0">
              <div class="text-sm font-medium text-gray-800 truncate">{{ u.firstName }} {{ u.name }}</div>
              @if(u.email) { <div class="text-xs text-gray-400 truncate">{{ u.email }}</div> }
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="rounded-xl border border-dashed border-gray-200 bg-white px-3 py-4 text-sm text-gray-400 italic text-center">No one assigned</div>
        }
      </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-between items-center px-6 py-3.5 border-t border-gray-100 shrink-0 bg-gray-50/50">
      <button type="button" (click)="deleteFromTaskDetail()" class="inline-flex items-center gap-2 px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg text-sm font-medium transition-colors cursor-pointer">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
        Delete
      </button>
      <div class="flex gap-2">
        <button type="button" (click)="closeTaskDetail()" class="px-4 py-2.5 text-gray-700 text-sm font-medium hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">Close</button>
        <button type="button" (click)="editFromTaskDetail()" class="inline-flex items-center gap-2 bg-blue-600 text-white text-sm font-semibold py-2.5 px-5 rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
          Edit Task
        </button>
      </div>
    </div>
  </div>
</div>
}

@if(showDeleteClientConfirm) {
<app-confirm-modal [message]="'Delete client &quot;' + selectedClient?.name + '&quot;? This cannot be undone.'" (close)="handleDeleteClientConfirm($event)"></app-confirm-modal>
}
